<template>
  <section class="row">
    <div class="col-xs-12">
      <template v-if="scoped.length">
        <div class="totals row">
          <div class="col-xs-12">
            <ul class="total-stats">
              <li>
                Total Orders <span>{{ scoped.length }}</span>
              </li>
              <li>
                Total Items <span>{{ item_count }}</span>
              </li>
              <li>
                Total Price <span>{{ asCurrency(subtotal) }}</span>
              </li>
              <li>
                Total Weight <span>{{ weight | fractional }} lbs</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div id="order-headers">
              <table class="table">
                <tbody>
                  <tr>
                    <th class="pickup-at">Pickup Time</th>
                    <th class="order-number">Order #</th>
                    <th class="customer-name">Customer</th>
                    <th class="items">Items</th>
                    <th class="total-price">Total $</th>
                    <th class="total-weight">Weight</th>
                  </tr>
                </tbody>
              </table>
            </div>

            <order
              v-for="order in scoped"
              :order.sync="order"
              track-by="id"
            ></order>
          </div>
        </div>
      </template>

      <div v-if="!scoped.length" class="text-center no-orders">
        <img src="../../assets/images/logo-sm.svg" /><br />
        There are no <b>{{ tab }}</b> orders.
      </div>

      <div v-if="!has_departments" class="text-center no-departments">
        <em
          ><b>Note:</b> This SFU is not associated with any
          <b>active</b> departments. No orders will appear on this device.</em
        >
      </div>
    </div>
  </section>
</template>

<script>
import { sortBy } from 'lodash';
import { asCurrency } from 'src/utilities';
import Order from '../Order';
import moment from 'moment';
import InteractsWithState from 'mixins/InteractsWithState';
import ScopesOrders from 'mixins/ScopesOrders';

export default {
  mixins: [InteractsWithState, ScopesOrders],

  computed: {
    has_departments() {
      return !this.state.store.id || this.state.departments.length > 0;
    },

    tab() {
      return this.$route.tab;
    },

    scoped() {
      if (!this.tab) {
        return [];
      }

      return sortBy(this[this.tab], order =>
        moment.utc(order.pickup_at).local()
      );
    },

    subtotal() {
      return this.scoped.reduce(
        (acc, order) => acc + Math.max(+order.subtotal, 0),
        0
      );
    },

    weight() {
      return this.scoped.reduce(
        (acc, order) => acc + Math.max(+order.weight, 0),
        0
      );
    },

    item_count() {
      return this.scoped.reduce((acc, order) => acc + order.item_count, 0);
    },
  },

  methods: {
    asCurrency,
  },

  components: { Order },
};
</script>

<style>
.no-departments {
  font-size: 0.8em;
  padding: 1em 0;
  color: rgba(0, 0, 0, 0.7);
}
</style>



// WEBPACK FOOTER //
// OrderSummary.vue?16c00ae4